import { z } from 'zod';
import { DEFAULT_OPTION, EMPTY_AIRPORT_OPTION, genderTypes } from './base-schemas';
import { EMPTY_FLIGHT_LEG, multiDestinationFlightEstimateSchema, oneWayFlightEstimateSchema, roundTripFlightEstimateSchema, } from './flight-schemas';
import { tourismEstimateSchema } from './tourism-schemas';
export const estimateFormSchema = z.union([
    oneWayFlightEstimateSchema,
    roundTripFlightEstimateSchema,
    multiDestinationFlightEstimateSchema,
    tourismEstimateSchema,
]);
export function getEstimateFormSchema(type) {
    switch (type) {
        case 'CRUISE':
        case 'STAY':
        case 'TOUR':
            return tourismEstimateSchema;
        case 'MULTI_DESTINATION':
            return multiDestinationFlightEstimateSchema;
        case 'ONE_WAY':
            return oneWayFlightEstimateSchema;
        case 'ROUND_TRIP':
            return roundTripFlightEstimateSchema;
        default:
            throw new Error(`Unknown estimate type: ${type}`);
    }
}
export const ESTIMATE_FORM_DEFAULT_VALUES = {
    // Start as FLIGHT type by default
    estimateType: 'FLIGHT',
    // Common fields
    clientFirstName: '',
    clientLastName: '',
    contactEmail: '',
    complementaryInformation: '',
    contactPhoneNumber: '',
    existingPassengerIds: [],
    newPassengers: [
        {
            firstName: '',
            lastName: '',
            birthDate: '',
            gender: genderTypes.male,
            nationality: DEFAULT_OPTION,
        },
    ],
    travelClass: 'ECONOMY',
    // FLIGHT-only fields (active when estimateType === 'FLIGHT')
    companyPreference: { companyName: DEFAULT_OPTION, hasPreference: false },
    flights: [{ ...EMPTY_FLIGHT_LEG }, { ...EMPTY_FLIGHT_LEG }],
    particularities: '',
    // type field: ROUND_TRIP for flights (consistent with 2 flight legs)
    type: 'ROUND_TRIP',
    // TOURISM-only fields (active when estimateType === 'TOURISM')
    // These are present but ignored when estimateType === 'FLIGHT'
    approximativeBudget: 0,
    carLoan: false,
    departure: EMPTY_AIRPORT_OPTION,
    departureDate: '',
    departureFlexibilityAfter: 0,
    departureFlexibilityBefore: 0,
    destination: EMPTY_AIRPORT_OPTION,
    hotelMinimumNumberOfStars: null,
    onSiteActivities: false,
    pension: 'ROOM_ONLY',
    returnDate: '',
    returnFlexibilityAfter: 0,
    returnFlexibilityBefore: 0,
    transfertFromAirport: false,
};
